import { UserSubscription } from '@/app/_lib/interfaces';
import { Zoc } from '@/app/_lib/zoc';

export const isB2BSubscription = (userSubscription?: UserSubscription) => {
  return userSubscription?.subscription_plan.type === 'b2b';
};

export const isB2CSubscription = (userSubscription?: UserSubscription) => {
  return userSubscription?.subscription_plan.type === 'b2c';
};

export const isPaidSubscription = (userSubscription?: UserSubscription) => {
  return (
    isB2BSubscription(userSubscription) || isB2CSubscription(userSubscription)
  );
};

export const canPerformPaidAction = (
  userSubscription?: UserSubscription,
  draftZoc?: Zoc
) => {
  const hasAccess =
    !(
      userSubscription?.subscription_plan.type === 'free' &&
      userSubscription.quota.remaining_zoc === 0
    ) ||
    // allow users to finalize draft zoc recordings
    draftZoc?.status === 'draft';

  return hasAccess;
};
